import { Component, PropsWithChildren } from "react";
import { withTranslation } from "react-i18next";

class ErrorBoundary extends Component<PropsWithChildren<any>> {
  state: { hasError: boolean } = { hasError: false };

  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.error(error);
  }

  render() {
    if (this.state.hasError) {
      return <h1>{this.props.t("errors.unknown")}</h1>;
    }

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
